import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { openWhatsApp, whatsappEnabled } from '../lib/whatsapp'
import { WhatsAppIcon } from './WhatsAppIcon'

// Floating WhatsApp entry point, bottom-right on every public page except
// checkout — there it would sit exactly on the Pay button, and checkout has
// its own inline help row instead. A plain button, zero third-party script:
// the wa.me URL is assembled on tap (see lib/whatsapp.ts for why).
export function WhatsAppBubble() {
  const location = useLocation()
  const { t } = useTranslation('common')
  if (!whatsappEnabled()) return null
  if (location.pathname.includes('/checkout')) return null
  return (
    <div className="wa-bubble-wrap">
      <span className="wa-bubble-chip">{t('whatsapp.bubbleChip')}</span>
      <button
        type="button"
        className="wa-bubble"
        aria-label={t('whatsapp.bubbleAria')}
        onClick={() => openWhatsApp(t('whatsapp.prefill'), 'bubble')}
      >
        <WhatsAppIcon size={26} />
      </button>
    </div>
  )
}
